import isHtzImage from './isHtmlVideoElement';
export default isHtzImage;
